import React, { FunctionComponent, useCallback, useEffect, useLayoutEffect } from 'react';
import useNavigationItems from '../../../hooks/navigation/useNavigationItems';
import useScrollToSection from '../../../hooks/navigation/useScrollToSection';
import useUpdateNavBarOnScroll from '../../../../common/hooks/navigation/useUpdateNavBarOnScroll';
import customise from '../../../constants/customise';
import expandSectionService from '../../../service/expandSectionService';
import NavigationBar from '../../../../gqlCommon/components/navigation/navigationBar/NavigationBar';
import { useHistory } from 'react-router-dom';
import customiseConstant from '../../../../customise/constants/customise';
import { delayedScrollToTopOnBack } from '../../../../gqlCommon/service/scrollUtilities';
import useCustomizeCarContext from '../../../hooks/useCustomizeCarContext';
import useNavigationBarContext from '../../../hooks/useNavigationBarContext';
import { ScrollInViewBehaviourType } from '../../../../common/service/scrollInView';

interface INavigationBarContainerProps {
  isCustomisePage?: boolean;
}

const NavigationBarContainer: FunctionComponent<INavigationBarContainerProps> = ({ isCustomisePage }) => {
  const { scrollToSection } = useScrollToSection();
  const { selectedCar } = useCustomizeCarContext();
  const { promotionalLabel1 } = selectedCar?.car?.attributes || {};
  const { selectedActiveSectionName, setSelectedActiveSectionName } = useNavigationBarContext();

  const { navigationItems } = useNavigationItems();
  const sections = navigationItems?.map(navSection => navSection.name);
  const { currentElement } = useUpdateNavBarOnScroll(sections, customise.DOM_ID_PREFIX);
  const history = useHistory();

  const changeSection = (name: string) => {
    scrollToSection(name, ScrollInViewBehaviourType.SMOOTH);
    setSelectedActiveSectionName(name);
    expandSectionService.setExpandSection(name);
  };

  const handleResize = useCallback(() => {
    const isPortraitMode = screen.width < screen.height || window.orientation === 0;
    const element = document.querySelector(
      `#${customiseConstant.NAVIGATION_BAR_ID} [data-test-selected="true"]`,
    ) as HTMLButtonElement;

    if (isPortraitMode && element) {
      setTimeout(() => {
        element.click();
        element.scrollIntoView({
          behavior: ScrollInViewBehaviourType.AUTO,
          inline: 'center',
        });
      }, 50);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [handleResize]);

  useLayoutEffect(() => {
    if (currentElement) {
      setSelectedActiveSectionName(currentElement);
    }
  }, [currentElement, setSelectedActiveSectionName]);

  useEffect(() => {
    const timeoutId = delayedScrollToTopOnBack(history);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [history]);

  return (
    <NavigationBar
      items={navigationItems}
      onClick={changeSection}
      activeItem={selectedActiveSectionName}
      isGraphql
      isCustomisePage={isCustomisePage}
      promotionalLabel={promotionalLabel1}
    />
  );
};

export default NavigationBarContainer;
